export default __webpack_public_path__ + "static/media/heroimg-signup.997777f1.png";